import { confirmByUserInput } from "lib/@dialogs/confirm-by-user-input"
import { useState } from "react"
import { removeFileFromRegister } from "./controller/remove-file-from-register"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { useUserByEmail } from "lib/user/use-user-by-email"
import { AssetRegisterRow } from "./asset-register-row"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { removableAssetsCountForWorkbook } from "./controller/removable-assets-count-for-workbook"

export function ImportedFilesTableRow({ row }) {
    const { importedBy, importedFrom, numberOfAssets, workbookIdentifier } = row
    const user = useUserByEmail(importedBy)
    const { register, refreshRegister } = useBoundContext()
    const [removing, setRemoving] = useState(false)

    return (
        <AssetRegisterRow
            row={row}
            remove={remove}
            removing={removing}
            showIcon={true}
            user={user}
            name={importedFrom}
            numberOfAssets={numberOfAssets}
        />
    )

    async function remove() {
        const totalAssetsInFile = numberOfAssets ?? 0
        let actualRemovals = totalAssetsInFile

        setRemoving(true)

        try {
            actualRemovals = await removableAssetsCountForWorkbook({
                registerId: register.id,
                workbookIdentifier,
            })
        } catch (e) {
            console.error(e.message)
            errorSnackbar(`Failed to check file removal impact: ${e.message}`)
            setRemoving(false)
            return
        }

        setRemoving(false)

        const sharedAssetsCount = Math.max(0, totalAssetsInFile - actualRemovals)

        if (
            await confirmByUserInput({
                title: `Are you sure you want to remove ${actualRemovals} ${"asset".pluralize(actualRemovals)} from the register?`,
                message:
                    sharedAssetsCount > 0
                        ? `This file contains ${totalAssetsInFile} ${"asset".pluralize(totalAssetsInFile)}. ${sharedAssetsCount} ${"asset".pluralize(sharedAssetsCount)} ${sharedAssetsCount === 1 ? "is" : "are"} also present in other imported files and will remain in the register.`
                        : "",
                confirmValue: actualRemovals,
            })
        ) {
            setRemoving(true)

            try {
                await removeFileFromRegister(register.id, workbookIdentifier)
            } catch (e) {
                console.error(e.message)
                errorSnackbar(`Failed to remove file: ${e.message}`)
                setRemoving(false)
                return
            }
            setTimeout(() => setRemoving(false), 400)
            refreshRegister()
            successSnackbar("File successfully removed")
        }
    }
}
